import { render, staticRenderFns } from "./OnBoard.vue?vue&type=template&id=7cec79f0&scoped=true&"
import script from "./OnBoard.vue?vue&type=script&lang=js&"
export * from "./OnBoard.vue?vue&type=script&lang=js&"
import style0 from "./OnBoard.vue?vue&type=style&index=0&id=7cec79f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cec79f0",
  null
  
)

export default component.exports